import React, { Component } from 'react'
import Cabecalho from '../components/cabecalho.js'
import Rodape from '../components/rodape.js'
import WelcomeScreen from '../screens/Welcome'
import IncidentScreen from '../screens/Incident'
import ReportCustomerScreen from '../screens/ReportCustomer'
import ReportCollavoratorScreen from '../screens/ReportCollaborator'
import { Routes, Route, BrowserRouter, Outlet } from "react-router-dom";
import UnsubscribeScreen from '../screens/Unsubscribe/index.js'
import UnsubscribeSuccess from '../screens/UnsubscribeSuccess/index.js'
import ServiceAnalysis from '../screens/ServiceAnalysis/index.js'
import ServiceAnalysisSuccess from '../screens/ServiceAnalysisSuccess/index.js'

function Router({servidor}) {
    const currentLocation = window.location.pathname;
    console.log(currentLocation.startsWith('/descadastrar'))

    return(
        <BrowserRouter>
            <Routes>
                        {
                            !currentLocation.startsWith('/descadastrar') && (
                                <>
                                    <Route 
                                        path="/" 
                                        element={                                    
                                            <div className="page">
                                                <link rel="stylesheet" type="text/css" href={'./css/'+ servidor +'.css'} />
                                                <Cabecalho servidor={servidor} />
                                                <div className="main main-bg">
                                                    <Outlet />
                                                </div>
                                                <Rodape servidor={servidor} />
                                            </div>
                                    }>
                                        <Route exact path="/" element={<ReportCollavoratorScreen servidor={servidor} />} />
                                        <Route exact path={"/bemvindo"} element={<WelcomeScreen servidor={servidor} /> } />
                                        <Route exact path={"/relatar"} element={<ReportCollavoratorScreen servidor={servidor} /> } />
                                        <Route exact path={"/relatarCliente"} element={<ReportCustomerScreen servidor={servidor} /> } />
                                        <Route path={"/incidente"} element={<IncidentScreen servidor={servidor} /> } />
        
                                    </Route>
                                    <Route exact path={"/service-analysis"} element={<ServiceAnalysis /> } />
                                    <Route path={"/service-analysis/success"} element={<ServiceAnalysisSuccess /> } />
                                </>
                            )
                        }
                        
                        {/* {
                            currentLocation.indexOf('exclusaoconta.') || currentLocation.indexOf('local') ? (
                                <> */}
                                    <Route exact path={"/service-analysis"} element={<ServiceAnalysis /> } />
                                    <Route path={"/descadastrar/sucesso"} element={<UnsubscribeSuccess /> } />
                                    <Route path={"/descadastrar"} element={<UnsubscribeScreen />} />
                                {/* </>
                            ) : null
                        } */}
            </Routes>
        </BrowserRouter>
    )
}

export default Router